import http from 'Services/HttpService';

import { baseUrl } from 'Utils/envLoader';

const AppService = {
    getAppById: (id) => {
        return http.get(`${baseUrl}/cliami/apps/${id}`);
    },

    getApps: () => {
        return http.get(`${baseUrl}/cliami/apps`);
    },

    saveApp: (form, appId) => {
        if (!appId) {
            return http.post(`${baseUrl}/cliami/apps/create`, form, {
                headers: {
                    ContentType: 'multipart/form-data',
                },
            });
        } else {
            return http.put(`${baseUrl}/cliami/apps/update/${appId}`, form, {
                headers: {
                    ContentType: 'multipart/form-data',
                },
            });
        }
    },

    toggleDisableApp: (appId) => {
        return http.put(`${baseUrl}/cliami/apps/toggle-disable/${appId}`);
    },

    deleteApp: (appId) => {
        return http.delete(`${baseUrl}/cliami/apps/${appId}`);
    },
};

export default AppService;
